import React from 'react'
import CreateProduct from './product/CreateProduct'

const VendorCreateProduct = () => {
  return (
    <div>
        <>
        <CreateProduct />
        </>
    </div>
  )
}

export default VendorCreateProduct
